module.exports = __webpack_public_path__ + "img/milk.7d63423f.png";